import React, { useEffect } from "react";
import { initializeAllFeatures } from "../../utils/interactiveFeatures";
import SmartNavigation from "../../components/Navigation/SmartNavigation";
import { AllSectionsUnified } from "../../components/BrandHomePage/AllSectionsUnified/AllSectionsUnified";
import { useTranslation } from "../../i18n";
import "./BrandHomePage.css";

const BrandHomePage: React.FC = () => {
  const { t } = useTranslation();

  // Initialize all interactive features
  useEffect(() => {
    initializeAllFeatures();
    window.scrollTo(0, 0);
  }, []);

  console.log("title: ", t('meta:home.title'));
  console.log("description: ", t('meta:home.description'));

  return (
    <div className="brand-home-page">

        <title>{t('meta:home.title')}</title>
        <meta name="description" content={t('meta:home.description')} />
        <meta property="og:title" content={t('meta:home.title')} />
        <meta property="og:description" content={t('meta:home.description')} />


      {/* Navigation - Fixed at top */}
      <header
        id="navigation"
        role="banner"
        aria-label={t('accessibility.landmarks.banner')}
      >
        <SmartNavigation
          defaultVariant="transparent"
          scrolledVariant="light"
          autoSwitchOnScroll={true}
          forceWhiteAssets={true}
        />
      </header>

      {/* All sections unified in one component for proper layering and animations */}
      <main
        id="main-content"
        role="main"
        aria-label={t('accessibility.landmarks.main')}
      >
        <AllSectionsUnified />
      </main>
    </div>
  );
};

export default BrandHomePage;
